import _ from "lodash"
import { Store } from "../store"
import { EventEmitter } from "../event-emitter"
import { Entity } from "../entity"
import { SchemaIds } from "../schema"

export class FeaturesImpl extends EventEmitter {
  public static FEATURES_CHANGED = 'FEATURES_CHANGED'

  apis: any
  store: any

  registrations: any[]

  createdListener: any
  changedListener: any
  deletedListener: any

  public async initialize(apis) {
    this.apis = apis
    this.store = apis.getStore()

    this.createdListener = this.store.addListener(Store.RECORD_CREATED, this.maybeRefreshListener)
    this.changedListener = this.store.addListener(Store.RECORD_CHANGED, this.maybeRefreshListener)
    this.deletedListener = this.store.addListener(Store.RECORD_DELETED, this.maybeRefreshListener)

    await this.loadData()
  }

  public dispose() {
    this.createdListener?.remove()
    this.changedListener?.remove()
    this.deletedListener?.remove()
  }

  private maybeRefreshListener = (record: Entity) => {
    if (!record.hasMixin(SchemaIds.SCHEDULER_ACCESS_REGISTRATION)) {
      return
    }

    void this.loadData()
  }

  private async loadData() {
    this.registrations = await this.apis.getFeatures()
    this.emit(FeaturesImpl.FEATURES_CHANGED)
  }

  public getAll() {
    return this.registrations
  }
}

export const features = new FeaturesImpl()
